import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { PricingOldContent } from 'client/contents/PricingOldContent/PricingOldContent'

type TProps = {}

const PricingOldPage: FC<TProps> = () => {
  return (
    <article className="flex w-full flex-col bg-surface-white">
      <AppHead />
      <PricingOldContent />
    </article>
  )
}

export default PricingOldPage
